import React from 'react';
import { useSelector } from 'react-redux';

import EmptyFavorites from './empty-favorites/EmptyFavorites';
import LoaderController from './loader-controller/LoaderController';
import GalleryFilters from './gallery-filters/GalleryFilters';
import MediaGallery from './media-gallery/MediaGallery';
import GalleryPagination from './gallery-pagination/GalleryPagination';

import scss from './FavoriteMedia.module.scss';

function FavoriteMedia({ additionalCardActions = [] }) {
  const favoriteMedia = useSelector((state) => state.aiStudio.favoriteMedia);

  return (
    <div className={scss.wrapper}>
      {!favoriteMedia.length ? <EmptyFavorites /> : null}

      {favoriteMedia.length ? (
        <div className={scss.mediaGallery}>
          <GalleryFilters />

          <MediaGallery favoriteMedia={favoriteMedia} additionalCardActions={additionalCardActions} />

          <GalleryPagination />
        </div>
      ) : null}

      <LoaderController />
    </div>
  );
}

export default FavoriteMedia;
